import { render, staticRenderFns } from "./ProfileTalentAvailability.vue?vue&type=template&id=bc138468"
import script from "./ProfileTalentAvailability.vue?vue&type=script&lang=js"
export * from "./ProfileTalentAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports